import { OfferUsableOption} from '@api/schema/offer/offer.usable-option';

export function getOptions (offer): Array<any> {
    const result = [];

    for (const service of offer.optionalServices) {
        if (service.items) {
            for (const serviceItem of service.items) {
                let pricing;

                if (serviceItem.prices) {
                    pricing = serviceItem.prices[0];
                }

                const usableOption = new OfferUsableOption();

                if (pricing) {
                    usableOption.price = pricing;
                    usableOption.prices = serviceItem.prices;
                }

                usableOption.id = serviceItem.id;
                usableOption.description = serviceItem.description;

                result.push(usableOption);
            }
        }
    }

    return result;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-options.ts